export const settingsMotion = {
  transition: { duration: 0.3 },
  animate: { top: -1, opacity: 1, translateY: '-100%' },
  initial: { top: 0, opacity: 0 },
  exit: { opacity: 0, top: 0 },
};
